import { useForm } from "@inertiajs/react"
import { useState } from "react"

import HeadingSmall from "@/components/heading-small"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { settingsUsersPath } from "@/routes"

export default function InviteUser() {
  const [error, setError] = useState<string | null>(null)

  const { data, setData, post, processing } = useForm({
    user: {
      email: "",
    },
  })

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setError(null)
    post(settingsUsersPath(), {
      preserveState: false,
      onSuccess: () => {
        setData("user.email", "")
        setError(null)
      },
      onError: (errors) => {
        setError(errors.email || errors["user.email"])
      },
    })
  }

  return (
    <div className="space-y-4">
      <HeadingSmall
        title="Invite a member"
        description="Invite new members by sending them an email."
      />
      <form className="flex max-w-lg items-start gap-4" onSubmit={handleSubmit}>
        <div className="relative flex-1">
          <Input
            type="email"
            name="user[email]"
            placeholder="member@example.com"
            value={data.user.email}
            required
            onChange={(e) => setData("user.email", e.target.value)}
            className="pr-32"
          />
        </div>
        <Button type="submit" variant="default" disabled={processing}>
          Invite
        </Button>
      </form>
      {error && <p className="text-destructive mt-2 text-sm">{error}</p>}
    </div>
  )
}
